<template>
  <div>
      <div class="error-message">beautiful 502 ({{ msg }})</div>
  </div>
</template>

<style type="scss">
</style>

<script>
  export default{
    data () {
      return {
        msg: 'hello vue'
      }
    },
    components: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/controllers/system/502.vue